import AuthenticationFormSubmitButtonStyle from './AuthenticationFormSubmitButton.style';

const AuthenticationFormSubmit1stButtonStyle = `
  ${AuthenticationFormSubmitButtonStyle}
  margin-top: 20px;
`;

export default AuthenticationFormSubmit1stButtonStyle;
